<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <v-row justify="space-between">
        <v-col cols="6">
          <h1>Сеты</h1>
        </v-col>
        <v-col cols="3" class="search-col">
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Поиск"
              single-line
              otlined
              hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12">

      <v-row>
        <v-col class="text-right">
          <v-btn @click="$router.push({ name: 'combo-product-create'})">Создать</v-btn>
        </v-col>
      </v-row>
      <v-data-table
          no-data-text="Нет"
          no-results-text="По заданному запросу ничего не найдено"
          :headers="headers"
          :items="comboProducts"
          :header-props="{sortIcon: 'icon-custom-arrow'}"
          :search="search"
          :options.sync="options"
          :footer-props="footerProps"
          :loading="loading"
          :items-per-page="-1"
          loading-text="Загрузка... Подождите пожалуйста"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'combo-product-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
        :z-index="4"
        :value="overlay"
    >
    </v-overlay>
    <v-dialog
        v-model="submitDialog"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
              v-if="submitItem == null"
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              v-else
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              outlined
              @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// @ is an alias to /src

import ComboProductService from './../../api/ComboProductService'

export default {
  name: 'ComboProductIndex',
  components: {},
  data: () => ({
    submitDialog: false,
    submitItem: null,
    selected: [],
    filters: {},
    tab: 0,
    overlay: false,
    search: '',
    loading: true,
    categories: [],
    options: {},
    footerProps: {
      itemsPerPageText: 'Элементов" на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [-1]
    },
    total: 0,
    headers: [
      {
        text: 'Дата создания',
        value: 'created_at',
        sortable: false,
      },
      {
        text: 'Iiko Id',
        value: 'iiko_id',
        sortable: false,
      },
      {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
    ],
    comboProducts: [],
  }),
  mounted() {
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search() {
      this.getDataFromApi()
    }
  },
  methods: {
    submitDelete(item = null) {
      this.removeComboProduct(item)
    },
    collectSelectedId() {
      let ids = [];
      this.selected.forEach(function (item) {
        ids.push(item.id)
      })

      return ids;
    },
    removeComboProduct(item) {
      ComboProductService.remove(item.id).then(response => {
        this.loading = true
        this.getDataFromApi()
      })
    },
    getDataFromApi() {
      this.loading = true

      let params = {
        search: this.search,
      }
      ComboProductService.list(params)
          .then(response => {
            this.comboProducts = response.data
            this.loading = false
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }

  &.v-card--link:focus::before {
    opacity: 0;
  }
}
</style>
